import styled from 'styled-components';

export const MilkTypeWrapper = styled.div`
position: relative;
 .actions {
  display: flex;
  align-items: baseline;
  justify-content: end;
  gap: 10px;
  margin-bottom: 10px;
 }
`